import http from './http.service';

class PaidServiceService {
    constructor() {
        if (PaidServiceService.instance) {
            return PaidServiceService.instance;
        }

        PaidServiceService.instance = this;
    }

    services() {
        return http.get('/services').then(res => res.data);
    }
    update(serviceId, data) {
        return http.put(`/services/${serviceId}/update`, data).then(res => res.data);
    }
}

export default new PaidServiceService();
